// @ts-nocheck
import _ from 'lodash'
import moment from 'moment'

const getDailyDesc = (props) => {
  const { freqInterval } = props

  return freqInterval === '1' ? 'every day' : `every ${freqInterval} days`
}

const getMultiDaysStr = (props) => {
  const { freqDaysInWeek } = props

  return _(freqDaysInWeek)
    .sortBy((day) => moment(day, 'ddd').format('d'))
    .sortBy((day) => day === 'Sun')
    .map((day, index) => {
      const freqDay = moment(day, 'ddd')
      const formatedFreqDay = freqDay.format('dddd')

      if (index === 0) {
        return `${formatedFreqDay}`
      }
      if (index === freqDaysInWeek.length - 1) {
        return ` and ${formatedFreqDay}`
      }

      return `, ${formatedFreqDay}`
    })
    .join('')
}

const getWeeklyDesc = (props) => {
  const { freqInterval, freqDaysInWeek } = props

  let daysString = ``

  if (freqDaysInWeek && freqDaysInWeek.length) {
    daysString = `on `
    daysString +=
      freqDaysInWeek.length === 1
        ? moment(freqDaysInWeek[0], 'ddd').format('dddd')
        : getMultiDaysStr(props)
  }

  return freqInterval === '1'
    ? `every week ${daysString}`
    : `every ${freqInterval} weeks ${daysString}`
}

export function getFrequencyDescription(props) {
  const { freqUnit } = props

  if (!freqUnit) return null

  switch (freqUnit) {
    case 'day':
      return getDailyDesc(props)
    case 'week':
      return getWeeklyDesc(props)
    default:
      return ''
  }
}
